import Plugin from '../core/model';
export var plugins = {};
export function registerPlugin(name, plugin) {
    plugins[name] = plugin;
}
export default Plugin;
